import { Token } from "@/pages/create-fund/components/select-tokens/select-tokens";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:8000";

const tokenListQuery = `${API_URL}/tokens`;
const createFundEndpoint = `${API_URL}/create-fund`;

const options: RequestInit = {
  method: "GET",
  mode: "cors",
  headers: {
    "Content-Type": "application/json",
  },
};

export const fetchTokenList = async (): Promise<Token[]> => {
  try {
    const res = await fetch(tokenListQuery, options);
    const data = await res.json();

    return data.map((token: any) => {
      const priceRaw = token.price_lovelace;
      const priceNumber =
        typeof priceRaw === "number"
          ? priceRaw
          : typeof priceRaw === "string"
            ? Number(priceRaw)
            : null;

      return {
        policy_id: (token.policyId || "").toLowerCase(),
        token_id: `${token.policyId || ""}${token.tokenName ?? ""}`.toLowerCase(),
        token_name: token.name || token.symbol || "",
        token_symbol: token.symbol || "",
        token_decimal_places: token.decimalPlaces ?? 0,
        token_image: token.image || "",
        token_price_lovelace:
          typeof priceNumber === "number" && priceNumber > 0
            ? priceNumber
            : null,
      };
    });
  } catch (e) {
    console.error("API FetchTokens ERROR::", e);
    return [];
  }
};

interface CreateFundParams {
  fundName: string;
  tokens: string[];
  tokenFactors: number[];
  fundFactor: number;
  royaltyFactor: number;
  creatorPkh: string | null;
  userAddress: string;
}

interface CreateFundResponse {
  cbor: string;
}

export const createFund = async (params: CreateFundParams): Promise<string> => {
  try {
    // Backend expects address as query param (matching create-fund.sh)
    const url = `${createFundEndpoint}?address=${encodeURIComponent(params.userAddress)}`;

    const body = {
      fund: {
        tokens: params.tokens,
        token_factors: params.tokenFactors,
        fund_factor: params.fundFactor,
        royalty_factor: params.royaltyFactor,
        creator_pkh: params.creatorPkh,
        fund_name: params.fundName,
      },
      user_address: params.userAddress,
    };

    console.log("Sending to backend:", { url, body });

    const res = await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });

    if (!res.ok) {
      const errorText = await res.text();
      console.error("Backend error response:", errorText);
      throw new Error(`Backend error: ${res.status} ${res.statusText} - ${errorText}`);
    }

    const data: CreateFundResponse = await res.json();
    return data.cbor;
  } catch (e) {
    console.error("API createFund ERROR::", e);
    throw e;
  }
};
